(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4820],{

/***/ 82740:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_error",
      function () {
        return __webpack_require__(55879);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);


var errorDescriptionMap = {
    "404": "This page could not be found.",
    "500": "Internal server error.",
    default: "This page could not be found."
};
// Mimic default Next error page
var Error = function(param) {
    var statusCode = param.statusCode, errorText = param.errorText;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.body.style.backgroundColor = "#000";
    }, []);
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            fontFamily: '-apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", "Fira Sans", Avenir, "Helvetica Neue", "Lucida Grande", sans-serif',
            height: "100vh",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "20px"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        borderRight: "1px solid rgba(255, 255, 255, .3)"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        style: {
                            display: "inline-block",
                            margin: "0",
                            padding: "10px 23px 10px 0",
                            fontSize: "24px",
                            fontWeight: "500",
                            verticalAlign: "top"
                        },
                        children: statusCode
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        fontSize: "14px",
                        fontWeight: "normal",
                        lineHeight: "inherit",
                        padding: "0 0 6px 0",
                        margin: "0"
                    },
                    children: (ref = errorText !== null && errorText !== void 0 ? errorText : errorDescriptionMap[statusCode]) !== null && ref !== void 0 ? ref : errorDescriptionMap["default"]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Error);


/***/ }),

/***/ 55879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);
/* harmony import */ var _components_Error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61036);



/*const handleClientSide404Redirect = (statusCode: number) => {
  if (typeof window !== 'undefined') {
    const ssgPages = ['/specialist/', '/practice/']
    const path = window.location.pathname

    if (ssgPages.some((p) => path.includes(p)) && !path.endsWith(`/${statusCode}`)) {
      // Navigate client to not existing path to trigger native 404 handling.
      // Next-serverless is not working with manual notFound: true since
      // it's losing the context entirely.
      window.location.href = `${window.location.href}/${statusCode}`
    }
  }
}*/ var ErrorPage = function(param) {
    var statusCode = param.statusCode;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Error__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        statusCode: statusCode
    });
};
ErrorPage.getInitialProps = function(param) {
    var res = param.res, err = param.err;
    var statusCode = 404;
    if (res === null || res === void 0 ? void 0 : res.statusCode) {
        statusCode = res.statusCode;
    } else if (err === null || err === void 0 ? void 0 : err.statusCode) {
        statusCode = err.statusCode;
    }
    return {
        statusCode: statusCode
    };
};
/* harmony default export */ __webpack_exports__["default"] = (ErrorPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(82740); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);